import React, { FC } from 'react';

const CircleMinusIcon: FC = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
    <circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='1.5' />
    <line
      x1='8'
      y1='12'
      x2='16'
      y2='12'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);

export default CircleMinusIcon;
